module.exports = __webpack_public_path__ + "img/githubLogoWhite.db30b2a9.svg";